import { Component, OnDestroy, ViewChild, HostListener, ViewChildren, QueryList } from '@angular/core';

import {SlideshowService} from '../slideshow.service';
import {ImagesService} from '../../shared/images.service';
import {ImageDetailsDialog} from '../images/image-details-dialog.component';
import { MatDialog } from '@angular/material';
import { SlideComponent } from '../slide/slide.component';

@Component({
    selector: 'writing-component',
    templateUrl: 'writing.component.html'
})
export class WritingComponent {
    showSlidenav = false;
    imagesOpen = false;

    @ViewChild('slidenav') slidenav;
    @ViewChildren(SlideComponent) slides: QueryList<SlideComponent>;
    
    constructor(
        private dialog: MatDialog,
        private imagesService: ImagesService,
        public slideshow: SlideshowService
    ) {}
    ngAfterViewInit() {
        setTimeout(() => {
            this.showSlidenav = true;
        }, 1000);
    }
    toggle(option) {
        this[option] = !this[option];
    }
    drop(e) {
        if( this.slideshow.locked ) {
            return;
        }
        this.imagesService.handleDropFiles(e.event.dataTransfer.files, this.slideshow.assignment, false);
    }
    popImageDialog(e, image) {
        if( e.target.classList.contains('mat-icon') || e.target.classList.contains('actions') ) {
            return;
        }
        const dialog = this.dialog.open(ImageDetailsDialog, {
            data: {
                image: image,
                canEdit: !this.slideshow.locked
            }
        });
    }
    // trigger view updates on all slides
    triggerSlideViewUpdates() {
        const slides = this.slides.toArray();
        for(var i = 0; i < slides.length; i++) {
            slides[i].cdr.markForCheck();
        }
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/tabs/writing.component.ts